import base from './base.repository'

export default {
    ...base,
    loadPetitions(filters, page) {
        const params = { ...filters, page }
        this.get(`petitions${this.querify(params)}`)
        return this
    },
    loadPetitionStatuses() {
        this.get('petitions/statuses')
        return this
    },
    loadPetitionTypes() {
        this.get('petitions/types')
        return this
    },
    loadPetitionCategories() {
        this.get('petitions/categories')
        return this
    },
    loadSubCategoriesByCategory(categoryId) {
        this.get(`petitions/sub-categories?category=${categoryId}`)
        return this
    },
    loadPetitionsByClient(clientId, filters, page) {
        const params = {
            client: clientId,
            creatoruser: filters.nameUser,
            status: filters.statusPetition,
            type: filters.typeId,
            page,
            dateFrom: filters.from,
            dateTo: filters.to,
        }
        const qs = this.querify(params)
        this.get(`petitions${qs}`)
        return this
    },
    loadPetitionsNotAssigned(filters, page, slugState = 'recibida') {
        const params = { ...filters, page, slugstatus: slugState }
        this.get(`petitions${this.querify(params)}`)
        return this
    },
    loadPetitionsAssigned(filters, page, slugState = 'asignada') {
        const params = { ...filters, page, slugstatus: slugState }
        this.get(`petitions${this.querify(params)}`)
        return this
    },
    loadPetitionsResolved(filters, page, slugState = 'resuelta') {
        const params = { ...filters, page, slugstatus: slugState }
        this.get(`petitions${this.querify(params)}`)
        return this
    },
    loadPetitionsByUserAssignments(
        userId,
        filters,
        page,
        slugState = 'asignada'
    ) {
        const params = { ...filters, page, user: userId, slugstatus: slugState }
        this.get(`petitions/assigned-user${this.querify(params)}`)
        return this
    },
    loadResolvedPetitionsByUser(userId, filters, page, slugState = 'resuelta') {
        const params = { ...filters, page, user: userId, slugstatus: slugState }
        this.get(`petitions/assigned-user${this.querify(params)}`)
        return this
    },
    savePetition(formData) {
        this.post('petitions', formData)
        return this
    },
    saveAssignation(assignation) {
        this.post('petitions/save-assignation', assignation)
        return this
    },
    saveCommentAssignation(comment) {
        this.post('petitions/save-comment', comment)
        return this
    },
    removeComment(commentId) {
        this.delete('petitions/remove-comment/' + commentId)
        return this
    },
    updateComment(payload, commentId) {
        this.put('petitions/update-comment/' + commentId, payload)
        return this
    },
    approvePetitionByCompany(id, payload) {
        this.post('petitions/' + id + '/approve-petition-by-company', payload)
        return this
    },
    setPetitionQualification(id, payload) {
        this.post('petitions/' + id + '/set-qualification-by-client', payload)
        return this
    },
    approvePetitionByClient(id, payload) {
        this.post('petitions/' + id + '/approve-petition-by-client', payload)
        return this
    },
    rejectPetitionByCompany(id, payload) {
        this.post('petitions/' + id + '/reject-petition-by-company', payload)
        return this
    },
    rejectPetitionByClient(id, payload) {
        this.post('petitions/' + id + '/reject-petition-by-client', payload)
        return this
    },
    markResolvedPetition(id, payload) {
        this.post('petitions/' + id + '/mark-resolved', payload)
        return this
    },
    uploadFiles(formData) {
        this.post('petitions/upload-files', formData)
        return this
    },
}
